export default __webpack_public_path__ + "static/media/banner-it-telecom-comp.ee1609be.jpg";